import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App.tsx';
import { NavProvider, ToastProvider } from './hooks.tsx';

export function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: { refetchOnWindowFocus: true, retry: (n, e) => n < 2 && (e as { status?: number }).status !== 401 },
    },
  });
}

export function Root({ client = makeQueryClient() }: { client?: QueryClient }) {
  return (
    <QueryClientProvider client={client}>
      <ToastProvider>
        <NavProvider>
          <App />
        </NavProvider>
      </ToastProvider>
    </QueryClientProvider>
  );
}
